import React from 'react';
import { ColorTokens, IconAlignmentTokens, IconSizeTokens, IconTokens } from '@voltmoney/schema';
import { Text, TouchableOpacity, View, } from 'react-native';
import { Icon } from "../icon/Icon";
import ThemeProvider from "@voltmoney/theme";
const AppBottomNav = ({ currentRoute, navigationAction, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    console.log("AppBottomNav here: ");
    const MenuItems = [
        {
            title: 'My Account',
            routeId: 'DASHBOARD',
            icon: {
                name: currentRoute === 'DASHBOARD' ? IconTokens.Chart : IconTokens.NOTSELCTEDCHART,
                size: IconSizeTokens.XL,
                align: IconAlignmentTokens.left,
                color: ColorTokens.Grey_Charcoal,
            },
            onPress: (navigationAction) => {
                navigationAction = {
                    ...navigationAction,
                    payload: {
                        ...navigationAction.payload,
                        routeId: 'DASHBOARD'
                    }
                };
                navigationAction &&
                    triggerAction(navigationAction);
            }
        },
        {
            title: 'Transactions',
            routeId: 'TRANSACTIONS',
            icon: {
                name: currentRoute === 'TRANSACTIONS' ? IconTokens.TransactionNotSelected : IconTokens.RuppeFile,
                size: IconSizeTokens.XL,
                align: IconAlignmentTokens.left,
                color: ColorTokens.Grey_Charcoal,
            },
            onPress: (navigationAction) => {
                navigationAction = {
                    ...navigationAction,
                    payload: {
                        ...navigationAction.payload,
                        routeId: 'TRANSACTIONS'
                    }
                };
                navigationAction &&
                    triggerAction(navigationAction);
            }
        },
        {
            title: 'Manage Limit',
            routeId: 'MANAGE_LIMIT',
            icon: {
                name: currentRoute === "MANAGE_LIMIT" ? IconTokens.ManageLimitSelected : IconTokens.ManageLimit,
                size: IconSizeTokens.XL,
                align: IconAlignmentTokens.left,
                color: ColorTokens.Grey_Charcoal,
            },
            onPress: (navigationAction) => {
                navigationAction = {
                    ...navigationAction,
                    payload: {
                        ...navigationAction.payload,
                        routeId: 'MANAGE_LIMIT'
                    }
                };
                navigationAction &&
                    triggerAction(navigationAction);
            }
        },
    ];
    return (React.createElement(View, { style: {
            height: 72,
            width: '100%',
            backgroundColor: '#FFF',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: 10,
            paddingVertical: 8,
            paddingBottom: 4
        } }, MenuItems &&
        MenuItems.map((item, index) => (React.createElement(TouchableOpacity, { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
            }, onPress: () => { item.onPress(navigationAction); } },
            React.createElement(View, { nativeID: 'txt_dashboard_' + item.routeId, style: {
                    paddingBottom: 4
                } },
                React.createElement(Icon, { name: item?.icon?.name, size: item?.icon?.size, color: currentRoute === item?.routeId ?
                        ColorTokens.Primary_100 :
                        ColorTokens.Grey_Charcoal })),
            React.createElement(View, null,
                React.createElement(Text, { style: {
                        fontFamily: 'Inter',
                        fontSize: 10,
                        fontWeight: currentRoute === item?.routeId ? '600' : '400',
                        color: currentRoute === item?.routeId
                            ? colorMapping[ColorTokens.Primary_100]
                            : '#667085',
                        textAlign: 'center',
                        lineHeight: 16
                    } }, item?.title)))))));
};
export default React.memo(AppBottomNav);
export { AppBottomNav };
